import { selectContentLibraryActiveWhiteboards } from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedWhiteboard } from 'features/content-library/types';
import {
  gridPanelOpened,
  gridPanelVoided,
  selectLockedWhiteboard,
} from 'features/layout/features/content/contentSlice';
import { pickLatestByDate } from 'features/content-library/utils/pickLatestByDate';
import { whiteboardViewed } from 'features/content-library/actions';
import { call, put, select } from 'redux-saga/effects';
import { board } from 'utils/whiteboard/BoardStateManager';

export function* openLastActiveWhiteboardSaga(id?: string) {
  const whiteboards: ContentLibraryOpenedWhiteboard[] = yield select(
    selectContentLibraryActiveWhiteboards
  );

  const filteredWhiteboards = whiteboards.filter((item) => item.id !== id);

  if (filteredWhiteboards.length === 0) {
    yield put(gridPanelVoided('whiteboard'));

    yield call(board.reset);

    return;
  }

  if (filteredWhiteboards.length > 0) {
    const lockedWhiteboard: ContentLibraryOpenedWhiteboard | undefined =
      yield select(selectLockedWhiteboard);

    const target = lockedWhiteboard ?? pickLatestByDate(filteredWhiteboards);

    yield put(whiteboardViewed(target.id));

    yield put(gridPanelOpened('whiteboard'));
  }
}
